import { Suspense, lazy } from "react";
import { LazySection } from "./components/ui/LazySection";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SEO } from "./components/SEO";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { useLenis } from "./hooks/useLenis";

const About = lazy(() => import("./components/About").then(module => ({ default: module.About })));
const Services = lazy(() => import("./components/Services").then(module => ({ default: module.Services })));
const TechStack = lazy(() => import("./components/TechStack").then(module => ({ default: module.TechStack })));
const Testimonials = lazy(() => import("./components/Testimonials").then(module => ({ default: module.Testimonials })));
const Blog = lazy(() => import("./components/Blog").then(module => ({ default: module.Blog })));
const FAQ = lazy(() => import("./components/FAQ").then(module => ({ default: module.FAQ })));
const Contact = lazy(() => import("./components/Contact").then(module => ({ default: module.Contact })));

const ThankYou = lazy(() => import("./pages/ThankYou"));
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Card = lazy(() => import("./pages/Card"));

const Home = () => (
  <>
    <SEO page="home" />
    <Hero />
    <LazySection><About /></LazySection>
    <LazySection><Services /></LazySection>
    <LazySection><TechStack /></LazySection>
    <LazySection><Testimonials /></LazySection>
    <LazySection><Blog /></LazySection>
    <LazySection><FAQ /></LazySection>
    <LazySection height="50vh"><Contact /></LazySection>
  </>
);

/* Pages that include the site Header + Footer */
const WithLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

import { ThemeProvider } from "./components/theme-provider";

function App() {
  useLenis();
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <div className="App bg-background min-h-screen transition-colors duration-300">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen flex text-white/50 items-center justify-center">Loading...</div>}>
            <Routes>
              {/* Standalone — no header / footer */}
              <Route path="/card" element={<Card />} />

              {/* All other routes share the site layout */}
              <Route path="/" element={<WithLayout><Home /></WithLayout>} />
              <Route path="/thank-you" element={<WithLayout><ThankYou /></WithLayout>} />
              <Route path="/blog" element={<WithLayout><BlogList /></WithLayout>} />
              <Route path="/blog/:slug" element={<WithLayout><BlogPost /></WithLayout>} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
